import { useSyncExternalStore } from 'react';
import SupportErrorDialog from './support/SupportErrorDialog';
import {
  dismissTransferReport,
  formatTransferReport,
  getTransferReports,
  subscribeTransferReports,
} from '@/services/transferDiagnostics';

/** Transfer adapter. The presentation can also be reused by non-transfer errors. */
export default function TransferErrorDialog() {
  const reports = useSyncExternalStore(
    subscribeTransferReports,
    getTransferReports
  );
  if (!reports.length) return null;
  // One copy includes every queued failure. A new report resets the copy state,
  // and one dismiss closes the batch instead of trapping users in modal queues.
  return (
    <SupportErrorDialog
      key={reports.map((report) => report.reportId).join(':')}
      reportText={reports.map(formatTransferReport).join('\n\n')}
      ariaLabel="Project transfer error"
      safetyNote="Keep your local files and backups until the transfer is confirmed."
      onClose={() =>
        reports.forEach((report) => dismissTransferReport(report.reportId))
      }
    />
  );
}
